import { useEffect, useState } from 'react';
import type { CreditSourceGroup } from '../types/CreditSourceGroup';
import { getCreditSourceGroups } from '../api/creditSourceGroups';

let cache: CreditSourceGroup[] | null = null;
let inflight: Promise<CreditSourceGroup[]> | null = null;

function load(): Promise<CreditSourceGroup[]> {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = getCreditSourceGroups()
    .then((data) => { cache = data; inflight = null; return data; })
    .catch((err: unknown) => { inflight = null; throw err; });
  return inflight;
}

export function clearCreditSourceGroupsCache(): void { cache = null; inflight = null; }

interface Result { data: CreditSourceGroup[] | null; loading: boolean; error: string | null; }

export function useCreditSourceGroups(): Result {
  const [state, setState] = useState<Result>(() =>
    cache ? { data: cache, loading: false, error: null } : { data: null, loading: true, error: null });
  useEffect(() => {
    if (cache) { setState((prev) => (prev.data === cache ? prev : { data: cache, loading: false, error: null })); return; }
    let cancelled = false;
    load()
      .then((data) => { if (!cancelled) setState({ data, loading: false, error: null }); })
      .catch((err: unknown) => { if (!cancelled) setState({ data: null, loading: false, error: err instanceof Error ? err.message : String(err) }); });
    return () => { cancelled = true; };
  }, []);
  return state;
}
